/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateTransferInputJsonApiModel = {
  id: "",
  transfer: {
    jsonApi: "hasOne",
    type: "transfers",
  },
  "new-holding-label": "",
};
